import GemstoneReportsClarityComp from "../GemstoneReportsClarityComp";
import GemstoneReportsGemTypeComp from "../GemstoneReportsGemTypeComp";
import GemstoneReportsColorComp from "../GemstoneReportsColorComp";
import GemstoneReportsCutGradeComp from "../GemstoneReportsCutGradeComp";
import GemstoneReportsShapeComp from "../GemstoneReportsShapeComp";
import GemstoneReportsCertificateComp from "../GemstoneReportsCertificateComp";
import GemstoneReportsSizeComp from "../GemstoneReportsSizeComp";
import GemstoneReportsClicksComp from "../GemstoneReportsClicksComp";
import { isValidShape } from "./isValidShape";
import { isValidCutGrade } from "./isValidCutGrade";


export const CLARITY_CONFIG = {
  key: "clarity",
  dataKey: "GemstoneClaritySearches",
  labelField: "Clarity",
  valueField: "CNT",
  dimensionLabel: "Clarity",
  pageTitle: "Gemstone Clarity Report",
  ChartCard: GemstoneReportsClarityComp,
  noiseFilter: null,
  detail: { reportName: "Clarity", filterParamName: "clarity", fileNamePart: "GemstoneClarityReports" },
};

export const GEMTYPE_CONFIG = {
  key: "gemType",
  dataKey: "GemstoneGemTypeSearches",
  labelField: "GemType",
  valueField: "CNT",
  dimensionLabel: "Gemstone Type",
  pageTitle: "Gemstone Type Report",
  ChartCard: GemstoneReportsGemTypeComp,
  noiseFilter: null,
  // The table SPs take no @GemType param (the API drops "gemType"), so the
  // clicked slice is applied through the server-side @SearchText instead.
  detail: { reportName: "GemType", filterParamName: "gemType", fileNamePart: "GemstoneGemTypeReports", filterViaSearchText: true },
};

export const COLOR_CONFIG = {
  key: "color",
  dataKey: "GemstoneColorSearches",
  labelField: "Color",
  valueField: "CNT",
  dimensionLabel: "Color",
  pageTitle: "Gemstone Color Report",
  ChartCard: GemstoneReportsColorComp,
  noiseFilter: null,
  detail: { reportName: "Color", filterParamName: "color", fileNamePart: "GemstoneColorReports" },
};

export const CUTGRADE_CONFIG = {
  key: "cutGrade",
  dataKey: "GemstoneCutGradeSearches",
  labelField: "CutGrade",
  valueField: "CNT",
  dimensionLabel: "Cut Grade",
  pageTitle: "Gemstone Cut Report",
  ChartCard: GemstoneReportsCutGradeComp,
  noiseFilter: { isValid: isValidCutGrade, toggleLabel: "Hide noise / invalid terms" },
  detail: { reportName: "CutGrade", filterParamName: "cutGrade", fileNamePart: "GemstoneCutReports" },
};

export const SHAPE_CONFIG = {
  key: "shape",
  dataKey: "GemstoneShapeSearches",
  labelField: "Cut", // shape label is stored under the "Cut" column in this table
  valueField: "CNT",
  dimensionLabel: "Shape",
  pageTitle: "Gemstone Shape Report",
  ChartCard: GemstoneReportsShapeComp,
  noiseFilter: { isValid: isValidShape, toggleLabel: "Hide noise / invalid terms" },
  detail: { reportName: "Shape", filterParamName: "shape", fileNamePart: "GemstoneShapeReports" },
};

export const CERTIFICATE_CONFIG = {
  key: "certificate",
  dataKey: "GemstoneCertificateSearches",
  labelField: "Certificate",
  valueField: "CNT",
  dimensionLabel: "Certificate",
  pageTitle: "Gemstone Certificate Report",
  ChartCard: GemstoneReportsCertificateComp,
  noiseFilter: null,
  detail: { reportName: "Certificate", filterParamName: "certificate", fileNamePart: "GemstoneCertificateReports" },
};

export const SIZE_CONFIG = {
  key: "size",
  dataKey: "GemstoneSizeSearches",
  labelField: "Size",
  valueField: "CNT",
  dimensionLabel: "Size",
  pageTitle: "Gemstone Size Report",
  ChartCard: GemstoneReportsSizeComp,
  noiseFilter: null,
  detail: { reportName: "Size", filterParamName: "size", fileNamePart: "GemstoneSizeReports" },
};

export const CLICKS_CONFIG = {
  key: "clicks",
  dataKey: "GemstoneClicks",
  labelField: "Date",
  valueField: "CNT",
  dimensionLabel: "Day",
  pageTitle: "Gemstone Clicks Report",
  ChartCard: GemstoneReportsClicksComp,
  noiseFilter: null,
  // "Total Day Searches" would just re-sum the same CNT column as Total
  // Clicks (redundant) — hide it in ReportKpiStrip for this report.
  hideTotalDimensionSum: true,
  // No detail table here — the GemstoneVendorTableChartAll SP has no verified
  // "Clicks" reportName branch, so ClicksIndComp wires ClickEventsTable
  // (DimondChart_SortingBindData) directly instead of DetailSearchTable.
};
